export enum CalendarGridTimeEventPlaceholderCssVars {
  yPosition = '--y-position',
  height = '--height',
}
